export function getPaymentChannelsV4BO(send) {
  return (query, ...args) =>
    send(
      {
        path: '/v4/payees/paymentChannels',
        pathParameters: {},
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
